import { useLocation } from "react-router-dom";

const Header = () => {
    const location = useLocation();
    const getTitle = () => {
        const path = location.pathname;
        if (path === '/') return 'Dashboard Overview';
        const title = path.replace('/', '').replace('-', ' ');
        return title.charAt(0).toUpperCase() + title.slice(1);
    }
    return (
        <header>
            <h1 className="text-3xl font-bold text-gray-800">{getTitle()}</h1>
            <p className="text-gray-500 mt-1">Welcome back, here's your restaurant's performance snapshot.</p>
        </header>
    );
};

export default Header;